export default ({ route, store }) => {
  if (!process.env.EQUALWEB_ENABLED || route.query.disableEqualWeb === 'true') {
    return;
  }

  let isActive = false;
  store.watch(state => {
    if (state._core.user.languageId && state.plataforma.user && state.plataforma.user.context && state.plataforma.user.context.isStudent) {
      if (isActive === false) {
        const language = {
          'pt-BR' : 'PT',
          en      : 'EN',
          es      : 'ES'
        }[state._core.user.languageId] || 'PT';

        window.interdeal = {
          sitekey  : '53ffcb8fa221161ef484bda708839f34',
          Position : 'Right',
          Menulang : language,
          domains  : {
            js  : 'https://cdn.equalweb.com/',
            acc : 'https://access.equalweb.com/'
          },
          btnStyle: {
            vPosition: [
              '55%',
              '45%'
            ],
            scale: [
              '0.6',
              '0.6'
            ],
            color: {
              main   : '#3b3a3b',
              second : '#ffffff'
            },
            icon: {
              type    : 1,
              shape   : 'semicircle',
              outline : false
            }
          }
        };

        (function(doc, head, body) {
          const coreCall           = doc.createElement('script');
          coreCall.src             = 'https://cdn.equalweb.com/core/4.6.3/accessibility.js';
          coreCall.defer           = true;
          coreCall.integrity       = 'sha512-+5lbZsIsOqyfEswqMIHyOrR4jrrBUQ0aVv0KYYoZ6/jTkKsTIqAHwkHgFEoRDM3NbjZ0lOxR0qSslbA3NIXrfw==';
          coreCall.crossOrigin     = 'anonymous';
          coreCall.setAttribute('data-cfasync', true);
          body ? body.appendChild(coreCall) : head.appendChild(coreCall);
        })(document, document.head, document.body);

        isActive = true;
      }
    }
  });
};
